var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yg-modal',{attrs:{"width":"800","title":_vm.model.id ? '编辑' : '新增'},on:{"on-sure":_vm.onSure,"on-close":_vm.onClose}},[_c('div',{staticStyle:{"min-height":"300px"},attrs:{"slot":"content"},slot:"content"},[_vm._v(" 1 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }